import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { DocumentRequestService } from 'src/app/v2-node-api/services/document-request.service';


@Component({
  selector: 'dialog-edit-request',
  templateUrl: './dialog-edit-request.component.html',
  styleUrls: ['./dialog-edit-request.component.scss']
})
export class DialogEditRequestComponent implements OnInit {
  requestForm: FormGroup;
  public documents: any[];
  disabled = false;
  color: ThemePalette = 'primary';
  checked = false;
  public form: FormGroup;
  public formArrayDocuments: FormArray;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogEditRequestComponent>,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    protected documentRequestService: DocumentRequestService) {
  }

  ngOnInit(): void {
    this.formArrayDocuments = new FormArray([]);

    this.form = new FormGroup({
      controls: this.formArrayDocuments,
      title: new FormControl(this.data.oldRequest.title, Validators.required),
     // status: new FormControl(this.data.oldRequest.status)
    });

    for (let doc of this.data.oldRequest.documents) {
      this.formArrayDocuments.push(new FormControl(doc.title, Validators.required));
    }
  }


  editRequest() {
    const {status, controls, title} = this.form.value;

    this.data.oldRequest.status = status;
    this.data.oldRequest.title = title;

    for(let i = 0; i < controls.length; i++) {
      this.data.oldRequest.documents[i].title = controls[i];
    }
    
    this.data.oldRequest.id = this.data.oldRequest._id;
    this.documentRequestService.updaterequest(this.data.oldRequest).subscribe(res => {
      this.dialogRef.close();
    });
  }
}
